import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, withModifiers as _withModifiers, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f08eb1c4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "multi-table-root" }
const _hoisted_2 = {
  key: 0,
  class: "multi-table-content"
}
const _hoisted_3 = { class: "header" }
const _hoisted_4 = { class: "table-name" }
const _hoisted_5 = { class: "shoe-juno" }
const _hoisted_6 = { class: "red-limit" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" 限红 ")
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "drop-down-icon" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "10.828",
    height: "6.828",
    viewBox: "0 0 10.828 6.828"
  }, [
    /*#__PURE__*/_createElementVNode("g", {
      id: "Component_15_1",
      "data-name": "Component 15 – 1",
      transform: "translate(9.414 1.414) rotate(90)"
    }, [
      /*#__PURE__*/_createElementVNode("line", {
        id: "Line_46",
        "data-name": "Line 46",
        x2: "4",
        y2: "4",
        fill: "none",
        stroke: "#393026",
        "stroke-linecap": "round",
        "stroke-width": "2"
      }),
      /*#__PURE__*/_createElementVNode("line", {
        id: "Line_47",
        "data-name": "Line 47",
        y1: "4",
        x2: "4",
        transform: "translate(0 4)",
        fill: "none",
        stroke: "#393026",
        "stroke-linecap": "round",
        "stroke-width": "2"
      })
    ])
  ])
], -1))
const _hoisted_9 = { class: "video-group" }
const _hoisted_10 = ["id"]
const _hoisted_11 = ["id"]
const _hoisted_12 = {
  key: 0,
  class: "video-loader"
}
const _hoisted_13 = { class: "game-no" }
const _hoisted_14 = { class: "btn-confirm-cancel-group" }
const _hoisted_15 = { class: "map-summary-group" }
const _hoisted_16 = { class: "road-map-summary" }
const _hoisted_17 = ["data-label"]
const _hoisted_18 = ["data-label"]
const _hoisted_19 = {
  class: "road-map-summary-item",
  "data-color": "green",
  "data-label": "和"
}
const _hoisted_20 = {
  key: 0,
  class: "road-map-summary-item",
  "data-color": "red",
  "data-label": "对"
}
const _hoisted_21 = {
  key: 1,
  class: "road-map-summary-item",
  "data-color": "blue",
  "data-label": "对"
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fill-row" }, null, -1))
const _hoisted_23 = {
  key: 0,
  class: "message-prompt"
}
const _hoisted_24 = { class: "message-prompt-container" }
const _hoisted_25 = { class: "message-msgbox-title-wrap" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "提示", -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bar-line" }, null, -1))
const _hoisted_28 = { class: "message-body-wrap" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "当前台桌已关闭访问，请选择其他台桌进行投注", -1))
const _hoisted_30 = { class: "btn-group" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_drop_down_2 = _resolveComponent("drop-down-2")!
  const _component_count_down_timer = _resolveComponent("count-down-timer")!
  const _component_bet_group = _resolveComponent("bet-group")!
  const _component_d_prediction_1 = _resolveComponent("d-prediction-1")!
  const _component_roadmap = _resolveComponent("roadmap")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.desk !== undefined)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.tableName), 1),
            _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.showAndJuNo), 1),
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _createVNode(_component_drop_down_2, {
                class: "drop-down",
                placeHolder: _ctx.redLimit,
                listData: _ctx.limitData,
                modelValue: -1
              }, {
                icon: _withCtx(() => [
                  _hoisted_8
                ]),
                _: 1
              }, 8, ["placeHolder", "listData"])
            ]),
            _createElementVNode("div", {
              class: "remove btn",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('remove', _ctx.position)))
            }, " 移除 ")
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("canvas", {
              ref: "videoRef1",
              id: `_video${_ctx.position}`,
              class: "bn1"
            }, null, 8, _hoisted_10),
            _createElementVNode("canvas", {
              ref: "videoRef2",
              id: `_video_${_ctx.position}`,
              class: "bn2"
            }, null, 8, _hoisted_11),
            (_ctx.videoIsLoading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_12))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_13, "编号" + _toDisplayString(_ctx.gameNo), 1),
            (_ctx.currentCount !== -1)
              ? (_openBlock(), _createBlock(_component_count_down_timer, {
                  key: 1,
                  class: "timer",
                  count: _ctx.currentCount
                }, null, 8, ["count"]))
              : _createCommentVNode("", true),
            _createElementVNode("div", {
              class: "enter-table btn",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.enterTable && _ctx.enterTable(...args)))
            }, "进入")
          ]),
          _createVNode(_component_bet_group, {
            ref: "refBetGroup",
            class: "bet-group",
            gameType: _ctx.gameType,
            mData: _ctx.desk,
            position: _ctx.position,
            onOnUpdate: _ctx.onPlaceTempBetOrClear
          }, null, 8, ["gameType", "mData", "position", "onOnUpdate"]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", {
              class: _normalizeClass(["btn-cancel", { btn: _ctx.hasTempBet }]),
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.cancelTempbet && _ctx.cancelTempbet(...args)))
            }, " 取消 ", 2),
            _createElementVNode("div", {
              class: _normalizeClass(["btn-confirm", { btn: _ctx.hasTempBet }]),
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.confirmTempBet && _ctx.confirmTempBet(...args)))
            }, " 确定 ", 2)
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", {
                class: "road-map-summary-item",
                "data-color": "red",
                "data-label": _ctx.gameType === 1 ? '庄' : '龙'
              }, _toDisplayString(_ctx.redCount), 9, _hoisted_17),
              _createElementVNode("div", {
                class: "road-map-summary-item",
                "data-color": "blue",
                "data-label": _ctx.gameType === 1 ? '闲' : '虎'
              }, _toDisplayString(_ctx.blueCount), 9, _hoisted_18),
              _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.greenCount), 1),
              (_ctx.gameType === 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_20, _toDisplayString(_ctx.redPairCount), 1))
                : _createCommentVNode("", true),
              (_ctx.gameType === 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_21, _toDisplayString(_ctx.bluePairCount), 1))
                : _createCommentVNode("", true)
            ]),
            _hoisted_22,
            _createVNode(_component_d_prediction_1, {
              class: "d-prediction-1 btn",
              color: 1,
              gameType: _ctx.gameType,
              mapdata: _ctx.nextRedRoadMapSummaryData,
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.predict(1)))
            }, null, 8, ["gameType", "mapdata"]),
            _createVNode(_component_d_prediction_1, {
              class: "d-prediction-1 btn",
              color: 2,
              gameType: _ctx.gameType,
              mapdata: _ctx.nextBlueRoadMapSummaryData,
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.predict(2)))
            }, null, 8, ["gameType", "mapdata"])
          ]),
          (_openBlock(), _createBlock(_component_roadmap, {
            key: _ctx.mapKey,
            ref: "roadmapview12",
            class: "road-map",
            display: 3,
            gameType: _ctx.gameType,
            enablePrediction: true,
            mapData: _ctx.mapData,
            onRoadMapData: _ctx.onRoadMapDataParsed
          }, null, 8, ["gameType", "mapData", "onRoadMapData"]))
        ]))
      : (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "btn-sellect-table btn",
          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('select-table')))
        })),
    _createVNode(_Transition, { name: "fadein-out" }, {
      default: _withCtx(() => [
        (_ctx.showMessageBox)
          ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("div", _hoisted_25, [
                  _hoisted_26,
                  _createElementVNode("div", {
                    class: "close-btn",
                    onClick: _cache[7] || (_cache[7] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.kickOutFromTable && _ctx.kickOutFromTable(...args)), ["prevent"]))
                  }),
                  _hoisted_27
                ]),
                _createElementVNode("div", _hoisted_28, [
                  _hoisted_29,
                  _createElementVNode("div", _hoisted_30, [
                    _createElementVNode("div", {
                      class: "btn-confirm",
                      onClick: _cache[8] || (_cache[8] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.kickOutFromTable && _ctx.kickOutFromTable(...args)), ["prevent"]))
                    }, " 确定 ")
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}